"use client";
import Image from "next/image";
import { Rocket } from "lucide-react";

const EmpoweringBanner = ({ totalEvents = 0 }) => {
  return (
    <section className="w-full bg-background-primary! !p-6 md:p-8 min-[2560px]:!p-20">
      <div className="mx-auto max-w-[4000px]">
        <div className="relative min-h-[140px] min-[2560px]:min-h-[320px] w-full overflow-hidden rounded-[24px] min-[2560px]:rounded-[50px] bg-[#0d0529] shadow-2xl flex items-center !p-6 md:!px-12 min-[2560px]:!px-24">
          <div className="absolute inset-0 w-full h-full z-0 pointer-events-none">
            <div className="relative w-full h-full flex justify-end">
              <div className="relative w-full md:w-[65%] lg:w-[60%] h-full">
                <Image src="/images/Global_Event/empowering_img.webp" alt="AI Technology" fill className="object-cover object-right mix-blend-screen opacity-100" priority />
                <div className="absolute inset-0 bg-[#0d0f1e]/50" />
              </div>
            </div>
            <div className="absolute inset-0 bg-gradient-to-r from-[#0d0529] via-[#0d0529]/90 to-transparent" />
          </div>

          <div className="relative z-20 flex flex-col md:flex-row items-center justify-between w-full !gap-6 min-[2560px]:!gap-20">
            <div className="flex items-center !gap-10 md:gap-12 lg:gap-16 min-[2560px]:!gap-24 flex-[1.5]">
              <div className="w-19 h-19 min-[2560px]:w-40 min-[2560px]:h-40 shrink-0 rounded-full bg-[#6d28d9] border-[3px] min-[2560px]:border-[8px] border-[#8b5cf6]/30 flex items-center justify-center shadow-[0_0_30px_rgba(109,40,217,0.4)] min-[2560px]:shadow-[0_0_70px_rgba(109,40,217,0.6)]">
                <Rocket className="w-8 h-8 min-[2560px]:w-18 min-[2560px]:h-18 text-white fill-white/10" strokeWidth={1.5} />
              </div>

              <h2
                className="text-[16px] md:text-[22px] lg:text-[26px] min-[2560px]:text-[52px] font-light text-white leading-tight tracking-tight max-w-[450px] min-[2560px]:max-w-[1000px]  min-[2560px]:text-[72px]  min-[2560px]:leading-[1.02]  min-[2560px]:tracking-[-0.04em]  min-[2560px]:max-w-[1100px]  min-[2560px]:font-normal
          "
              >
                Empowering Businesses with AI-Driven Technology Solutions for the Digital Future
              </h2>
            </div>

            <div className="flex flex-1 justify-center md:justify-start lg:justify-center">
              <div className="flex items-center !gap-3 min-[2560px]:!gap-8 !px-6 !py-5 min-[2560px]:!px-14 min-[2560px]:!py-10 rounded-2xl min-[2560px]:rounded-[36px] border border-white/20 bg-white/10 backdrop-blur-xl">
                <span className="text-[52px] md:text-[48px] lg:text-[44px] min-[2560px]:text-[110px] font-bold text-white leading-none tracking-tighter">{totalEvents}</span>
                <div className="flex flex-col justify-center">
                  <span className="text-[16px] md:text-[14px] lg:text-[16px] min-[2560px]:text-[32px] font-bold uppercase text-white leading-none mb-1">Events</span>
                  <span className="text-[12px] md:text-[14px] lg:text-[16px] min-[2560px]:text-[26px] text-zinc-300 font-normal">And Counting...</span>
                </div>
              </div>
            </div>

            <div className="hidden lg:flex flex-1"></div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default EmpoweringBanner;
